export default {
  labels: {
    today: 'Tänään',
    pickup_time: 'Noutoaika',
    on_site_time: 'Tarjoiluaika',
    delivery_time: 'Toimitusaika',
  },
};
